module.exports = __webpack_public_path__ + "static/media/cal-1.ba44e379.jpeg";